const PLACES_QUERY_MIN_LENGTH = 3;

/** Places autocomplete is billed per request. A saved address that already matches the query is enough. */
export const shouldFetchPlaceSuggestions = (query: string, savedAddressNames: readonly string[]): boolean => {
  const normalized = query.trim().toLowerCase();
  if (normalized.length < PLACES_QUERY_MIN_LENGTH) {
    return false;
  }
  return !savedAddressNames.some((name) => name.toLowerCase().includes(normalized));
};
